import { render, staticRenderFns } from "./notifyList.vue?vue&type=template&id=2f6ac940&scoped=true"
import script from "./notifyList.vue?vue&type=script&lang=js"
export * from "./notifyList.vue?vue&type=script&lang=js"
import style0 from "./notifyList.vue?vue&type=style&index=0&id=2f6ac940&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f6ac940",
  null
  
)

export default component.exports